function osmo_calc( values ) {
	/* if ( !values.alcohol ) {
		return 1.86 * ( values.sodium + values.potassium ) + 1.15 * values.glucose + values.urea + 14
	} else {
		return 1.86 * ( values.sodium + values.potassium ) + 1.15 * values.glucose + values.urea + 1.2 * values.ethanol * 14
	} */

	return 1.86 * ( values.sodium + values.potassium ) + 1.15 * (values.glucose * 0.0555) + (values.urea * 0.1605) + 14
}